import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/manager/schedule.vue'
wx.createPage(MiniProgramPage)